export type DelegationOptionsParams = Partial<{
	companyId: number;
}>;

export type ApiDelegationOptionsParams = Partial<{
	company_filter: number;
}>;

export const mapDelegationOptionsParamsToApi = (
	params?: DelegationOptionsParams,
): ApiDelegationOptionsParams | undefined => {
	if (!params) return undefined;

	const apiParams: ApiDelegationOptionsParams = {};

	if (params.companyId !== undefined) apiParams.company_filter = params.companyId;

	return apiParams;
};
